// extracted by mini-css-extract-plugin
module.exports = {"content":"LegendeAbsenceContentLigne_content__2buuL","mobile":"LegendeAbsenceContentLigne_mobile__1cLeM","desktop":"LegendeAbsenceContentLigne_desktop__eBkcp"};